import type { ReactNode } from 'react'
import { SearchItem } from './searchTypes'

// The filters of the circle/role picker. They sort results, they never hide
// them: with an empty field the list shows the filter alone, and while typing
// the rest follows under "Elsewhere in the organisation" (ORG-02).
// "Meeting circle" = the circle of the meeting the form was opened from, its
// roles and sub-circles (#123). "My roles" = circles the current member is a
// direct member of. "My circles" = the direct parent circle of each of those
// roles. "All" = whole org, flat.
export type CirclePerimeter = 'meetingCircle' | 'myRoles' | 'myCircles' | 'all'

// The filters offered (#123): in a meeting, the meeting's circle and the whole
// org; elsewhere, my roles, my circles and the whole org.
export function offeredPerimeters(inMeeting: boolean): CirclePerimeter[] {
  return inMeeting
    ? ['meetingCircle', 'all']
    : ['myRoles', 'myCircles', 'all']
}

// The filter a picker opens on: the one the screen asks for when it is
// offered, otherwise the first offered — in a meeting, the meeting's circle.
export function initialPerimeter(
  offered: CirclePerimeter[],
  wanted: CirclePerimeter
): CirclePerimeter {
  return offered.includes(wanted) ? wanted : offered[0]
}

// Wiring passed by the circle picker wrappers (CircleSearchButton/Input) down
// to the generic SearchButton/SearchInput -> useSearch pipeline. Kept as a
// single optional prop so unrelated pickers (member/thread/base-role search)
// are completely unaffected when it is absent.
export interface SearchPerimeterProps {
  // Rendered at the top of the results list (#123): the filters, visible as
  // soon as the list opens.
  header: ReactNode
  // True if an item belongs to the current perimeter.
  isInPerimeter(item: SearchItem): boolean
  // False for the "all" (whole org) perimeter: no partition, flat list.
  isPartitioned: boolean
  // i18n label of the separator row shown between in/out-of-perimeter groups.
  separatorLabel: string
}
